"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Callbacks = (function () {
    function Callbacks() {
    }
    Callbacks.didActivateTrigger = function (triggerType, triggerId) {
        this.sendMessage("did_activate_trigger", {
            trigger_type: triggerType,
            trigger_id: triggerId,
        });
    };
    Callbacks.didHoverTrigger = function (triggerType, triggerId) {
        this.sendMessage("did_hover_trigger", {
            trigger_type: triggerType,
            trigger_id: triggerId,
        });
    };
    Callbacks.didUnhoverTrigger = function () {
        this.sendMessage("did_unhover_trigger", {});
    };
    Callbacks.didChangeBackgroundColor = function () {
        this.sendMessage("did_change_background", {});
    };
    Callbacks.didCompleteSceneLoad = function (sceneId, format, formatVersion) {
        this.sendMessage("did_complete_scene_load", {
            scene: sceneId,
            format_id: format,
            formatVersion: formatVersion,
        });
    };
    Callbacks.didFailToLoadCallback = function (error) {
        this.sendMessage("did_fail_to_load", { error: error });
    };
    Callbacks.didEnterContext = function (context) {
        this.sendMessage("did_enter_context", {
            context: context,
        });
    };
    Callbacks.didExitContext = function (context) {
        this.sendMessage("did_exit_context", {
            context: context,
        });
    };
    Callbacks.didPause = function () {
        this.sendMessage("did_pause");
    };
    Callbacks.didResume = function () {
        this.sendMessage("did_resume");
    };
    Callbacks.didTriggerEvent = function (event, param) {
        this.sendMessage("did_trigger_event", {
            event_code: event,
            param: param,
        });
    };
    Callbacks.didListTriggers = function (triggers) {
        this.sendMessage("did_list_triggers", {
            triggers: triggers,
        });
    };
    Callbacks.didShowPopup = function (title) {
        this.sendMessage("did_show_popup", {
            title: title,
        });
    };
    Callbacks.didHidePopup = function (title) {
        this.sendMessage("did_hide_popup", {
            title: title,
        });
    };
    Callbacks.customMessage = function (message) {
        this.sendMessage("custom_message", {
            message: message,
        });
    };
    Callbacks.sendMessage = function (identifier, data) {
        if (data === void 0) { data = null; }
        var message = {
            event_id: "vf." + identifier,
        };
        if (data != null) {
            message["params"] = data;
        }
        if (window.location !== window.parent.location) {
            window.parent.postMessage(message, Callbacks.origin);
        }
        else {
            window.postMessage(message, Callbacks.origin);
        }
    };
    Callbacks.origin = "*";
    return Callbacks;
}());
exports.Callbacks = Callbacks;
